import { render, staticRenderFns } from "./productReqCom.vue?vue&type=template&id=1758e4be&scoped=true"
import script from "./productReqCom.vue?vue&type=script&lang=js"
export * from "./productReqCom.vue?vue&type=script&lang=js"
import style0 from "./productReqCom.vue?vue&type=style&index=0&id=1758e4be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1758e4be",
  null
  
)

export default component.exports